var _defs, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManorHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n        font-family: Futura-Medium, Futura;\n        font-size: 19.22px;\n        font-weight: 500;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-4 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-5 {\n        letter-spacing: 0em;\n      }\n\n      .cls-6 {\n        letter-spacing: .02em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M666.76,282.73c.26-.39.75-.78.75-1.17.04-11.2.03-22.41.03-33.61,0-1.04.37-2.28-.06-3.09-1.88-3.51.07-5.14,2.79-6.69,17.75-10.13,35.5-20.25,53.19-30.48,27.4-15.84,54.74-31.79,82.13-47.66,19.4-11.24,38.89-22.33,58.2-33.72,2.42-1.43,4.04-1.61,6.34-.31,10.65,6.05,21.41,11.93,32.04,18.02,13.73,7.87,27.36,15.91,41.08,23.81,12.75,7.34,25.64,14.44,38.29,21.94,16,9.47,31.8,19.29,47.74,28.86,9.72,5.83,19.54,11.48,29.32,17.21,0,0,4.32,3.19,4.67.78.26-1.79-.63-2.61-2.27-3.6-19.77-11.98-39.33-24.3-59.13-36.21-18.12-10.9-36.42-21.5-54.74-32.06-15.83-9.12-31.8-17.98-47.69-27-9.54-5.42-19.04-10.92-28.55-16.41-2.13-1.23-3.78-1.6-6.33-.1-21.27,12.56-42.66,24.92-64.08,37.22-22.38,12.84-44.9,25.43-67.23,38.36-17.19,9.96-34.15,20.32-51.27,30.42-5.12,3.02-10.42,5.74-15.63,8.63-4.25,2.35-7.44,5.68-10.27,9.7-4.32,6.13-9.29,11.79-13.98,17.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M432.51,276.09c-2.61-6.51-5.29-13-7.79-19.55-1.22-3.19-1.36-7.11-3.36-9.6-2.25-2.79-6.02-4.38-9.19-6.41-15.11-9.66-30.34-19.13-45.33-28.97-24.21-15.89-48.31-31.92-72.35-48.06-17.44-11.71-34.7-23.67-52.02-35.55-1.37-.94-2.64-2.05-3.92-3.12-3.7-3.1-5.57-3.27-9.39-.78-12.38,8.08-24.72,16.22-37.16,24.21-18.73,12.04-37.66,23.79-56.26,36.03-13.77,9.06-27.06,18.84-40.74,28.04-15.43,10.38-31.7,19.34-48.46,27.41-1.53.73-2.96,1.66-4.42,2.5,2.14,4.34,2.96,4.69,6.75,2.56,8.24-4.64,16.59-9.11,24.61-14.11,14.07-8.79,28.01-17.8,41.86-26.94,22.75-15.01,45.32-30.28,68.08-45.28,14.88-9.8,29.97-19.3,44.95-28.96,4.57-2.95,4.44-2.83,9.02.37,13.37,9.33,26.71,18.7,40.28,27.74,23.5,15.64,47.16,31.05,70.76,46.54,21.24,13.95,42.49,27.88,63.74,41.82,1.42.93,2.92,1.76,4.29,2.76,1.74,1.27,3.23.79,4.71-.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M836.87,519.17c-8.1,1.76-16.35,3.12-23.09,8.58-.16.13-.59-.09-.76.03-5.56,4.14-5.26,8.67.77,12.5,8.29,5.26,17.65,7.74,27,10.11,8.67,2.19,17.41,4.22,26.2,5.83,7.23,1.32,14.57,2.12,21.89,2.77,9.89.87,19.81,1.35,29.72,2.01,1.57.1,3.13.35,4.69.37,12.25.16,24.51.51,36.76.34,14.27-.19,28.49-1.07,42.64-3.36,10.79-1.75,21.55-3.34,31.24-8.74,3.91-2.18,8.22-4.62,7.33-10.1-.43-2.6-1.64-5.62-3.52-7.3-3.32-2.98-7.27-5.41-11.26-7.47-3.41-1.77-7.25-2.7-10.9-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.46,469.14c-2.91,5.51-2.01,11.36-1.65,17.2.07,1.14-.68,2.63-1.53,3.46-2.18,2.12-4.54,4.09-7.01,5.88-2.22,1.61-3.57,3.21-3.62,6.29-.07,4.28-.45,4.29,3.65,4.3,13.3,0,26.59.05,39.89-.01,11.21-.06,22.42-.32,33.63-.36,46.93-.16,93.85-.26,140.78-.45,1.7,0,4.74-.51,4.85-1.16.42-2.58,1.05-5.62-1.35-7.75-2.9-2.58-5.94-5.02-9.01-7.41-.55-.43-1.53-.43-2.31-.41-5.08.09-10.17.36-15.25.34-7.04-.02-14.08-.18-21.12-.41-1.18-.04-2.91-.37-3.43-1.18-2.74-4.27-7.09-3.75-11.04-3.79-16.16-.15-32.33-.11-48.49-.05-18.12.07-36.24.25-54.36.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1057.43,
    y1: 235.56,
    x2: 1057.42,
    y2: 461.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M651.51,497.67c-1.56.13-3.13.37-4.69.37-57.75.02-115.49-.03-173.24.05-12.77.02-25.55.51-38.32.71-1.3.02-2.61-.48-3.91-.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.88,245.6c0,8.08.01,16.15-.02,24.23,0,.91-.35,1.82-.36,2.74-.15,15.37-.27,30.74-.41,46.11-.12,14.07-.16,28.14-.41,42.21-.44,24.62-1,49.24-1.56,73.86-.16,7.17-.48,14.33-.8,21.49-.04.92-.49,1.83-.75,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M484.91,510.18c-2.74,4.3-5.91,8.39-8.09,12.95-2.34,4.88-5.9,9.69-4.71,15.56.63,3.11,1.6,6.54,3.54,8.92,8.53,10.47,18.08,19.95,28.79,28.28,9.06,7.05,17.42,15.03,26.71,21.73,17.42,12.56,34.85,25.19,53.92,35.23,15.52,8.18,31.16,16.15,46.94,23.82,11.96,5.81,24.21,11.01,36.34,16.46.33.15.77.02,1.16.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M681.62,317.12c-5.47-.13-10.95-.32-16.42-.38-6.39-.07-12.77.02-19.16-.02-18.38-.11-36.76-.29-55.14-.38-34.8-.16-69.61-.31-104.41-.38-10.3-.02-20.6.22-30.89.4-.92.02-2.08.22-2.7.79-5.67,5.27-11.23,10.66-16.87,15.97-1.78,1.67-3.01,3.37-1.58,5.89.22.4.03,1.02.03,1.55,0,17.46.04,34.91-.02,52.37-.03,9.9-.27,19.8-.37,29.7-.15,14.46-.27,28.92-.4,43.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M908.82,494.16c-5.34-.78-10.68-1.65-16.04-2.32-5.98-.75-12.02-1.1-17.98-2.03-8.64-1.35-17.22-.01-25.82.11-7.04.1-14.08.76-21.12,1.11-16.42.81-32.85,1.55-49.27,2.36-6.91.34-13.88.34-20.71,1.27-10.61,1.44-21.15,3.44-31.68,5.4-14.23,2.63-28.41,5.54-42.64,8.15-7.52,1.38-15.44,1.42-22.59,3.82-7.63,2.56-15.54,3.35-23.2,5.44-6.57,1.8-13.57,1.96-20.28,3.35-8.66,1.8-17.23,4.06-25.81,6.23-1.26.32-2.47,1.11-3.51,1.93-5.03,3.98-6.44,7.08-1.2,12.87,6.6,7.28,15.24,11.43,23.86,15.63,17.6,8.59,35.04,17.53,52.83,25.71,24.14,11.1,48.64,21.41,73.9,29.7,22.68,7.44,45.55,14.29,68.42,21.15,21.45,6.44,43,12.56,64.51,18.79,13.16,3.81,26.33,7.57,39.5,11.32.88.25,1.82.28,2.73.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.33,333.92h13.49v-12.11h-104.08c-.17,2.45-.37,4.94-.51,7.43-.07,1.17-.01,2.35-.01,4.3h12.12c23.72,0,47.45-.01,71.17.02,2.35,0,4.69.24,7.04.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M595.19,341.74c-.13,3.65-.34,7.29-.37,10.94-.06,7.17-.02,14.33-.02,21.69h41.26v-33.22h-187.71v33.22h41.65v-32.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.24,527.76c-6.26,1.56-12.44,3.58-18.79,4.58-9.19,1.46-18.5,2.1-27.75,3.25-17.95,2.24-36,2.04-53.96,1.36-18.3-.7-36.7-2.27-54.3-7.82-6.2-1.95-12.22-2.12-18.44-2.15-7.82-.03-15.65-.25-23.46.04-15.91.61-31.81,1.5-47.71,2.3-10.17.51-20.35.88-30.5,1.61-6.93.5-13.82,1.53-20.73,2.28-2.86.31-5.73.53-8.6.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.13,483.21c.28-34.78.56-69.57.84-104.54h96.92v4.1c0,27.36.02,54.71-.02,82.07,0,6.12-.24,12.25-.37,18.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M545.92,199.49v-6.84c-3.82,2.89-7.25,5.37-10.55,8.02-21.66,17.43-43.22,34.98-64.95,52.33-19.72,15.75-39.61,31.29-59.42,46.92-.8.63-1.57,1.3-2.35,1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.7,194.02c6.39,5.08,12.77,10.17,19.16,15.24,14.46,11.47,28.96,22.9,43.4,34.4,10.08,8.03,20.12,16.1,30.11,24.23,13.72,11.16,27.42,22.35,41.03,33.64,2.22,1.84,4.1,1.9,6.29.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.11,333.53c2.86.16,5.73.33,8.8.5v-11.64h-101.28v11.14h92.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M653.85,337.05c-.13,1.17-.37,2.34-.38,3.52-.15,42.08-.28,84.15-.41,126.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M675.36,317.51c0,14.98.04,29.96,0,44.94-.1,27.62-.07,55.24-.51,82.85-.11,6.82,1.78,13.24,2.23,19.92.25,3.7,2.21,7.26,2.88,10.97.35,1.97-.37,4.16-.69,6.23-.17,1.12-.51,2.22-.77,3.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M814.97,337.83c3.13-.39,6.26-.78,9.58-1.2v-9.94h-92.88v9.9c12.9.15,25.81.32,38.71.45,14.21.15,28.42.26,42.63.41.52,0,1.04.24,1.56.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.26,440.61c-2.09.21-4.19.42-6.45.64v7.95h4.11c29.33,0,58.66.02,87.99-.05,1.43,0,3.81-.38,4.11-1.19.64-1.72.44-3.89.05-5.76-.12-.58-1.94-1.14-2.99-1.15-7.82-.1-15.64-.05-23.46-.05-19.55,0-39.11,0-58.66-.02-1.43,0-2.87-.24-4.3-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M814.97,440.22h8.8v8.21h-92.29v-7.38c27.42-.93,55.07-.21,82.71-.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M991.34,439.44c.13-1.43.37-2.87.37-4.3.03-11.07-.03-22.15.03-33.22.08-14.46.27-28.92.37-43.38.05-6.64,0-13.29,0-20.45,2.72-.15,5.09-.29,7.63-.43v-10.19h-87.01v9.3c4.55.35,9.12.94,13.69,1.01,16.81.24,33.63.25,50.45.46,5.09.06,10.17.49,15.25.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.15,524.64c2.87.52,5.72,1.23,8.61,1.53,8.72.88,17.46,1.6,26.2,2.38,7.43.66,14.85,1.37,22.29,1.94,7.95.6,15.9,1.15,23.85,1.56,18.38.97,36.76,1.79,55.14,2.78,6.01.33,11.99,1.01,17.99,1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M680.44,302.27c-4.84.79-8.71.28-13.05-3.34-27.74-23.14-55.91-45.76-83.93-68.57-12.5-10.18-24.95-20.42-37.61-30.78-8.66,6.94-17.21,13.77-25.75,20.63-19.43,15.62-38.82,31.3-58.28,46.88-13.25,10.61-26.59,21.11-39.87,31.68-1.23.98-2.35,2.08-3.53,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M425.08,317.12c-.13,44.16-.23,88.32-.42,132.48-.04,8.21-1.18,16.47-.48,24.6.39,4.48.08,7.87-3.02,10.96-.46.46-1.03,1.12-1.56,1.13-4.17.09-8.37.35-12.5-.05-2.98-.29-5.09-4.9-4.72-8.89.13-1.42.57-3.23-.1-4.22-1.27-1.87-.31-2.96.47-4.4.58-1.07,1.3-2.41,1.11-3.48-.44-2.47.52-4.46,1.2-6.68,1.9-6.19,3.32-12.53,5.21-18.72,1.08-3.56.45-7.02.45-10.57.05-25.4.48-50.8.63-76.21.07-11.85-.23-23.71-.36-35.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M684.35,310.48c4.93.52,7.03-1.29,6.6-5.86-.08-.81-.54-1.8-1.16-2.31-9.21-7.74-18.36-15.55-27.76-23.06-17.9-14.31-35.97-28.41-53.94-42.64-15.41-12.21-30.77-24.48-46.15-36.72-1.02-.81-2.1-1.54-3.12-2.36-.94-.75-2.72-1.73-2.6-2.31,1.06-5.35-4.22-5.56-6.38-8.24-2-2.47-4.02-2.09-6.28-.4-1.88,1.4-3.8,2.81-5.88,3.88-2.26,1.16-2.27,2.76-1.54,4.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.45,471.49c-3.77-2.35-4.5.97-5.95,3.11-1.61-.5-3.32-.97-4.99-1.57-.7-.25-1.77-.65-1.89-1.17-.7-3.06-3-3.61-5.69-3.89,2.05-5.27-2.93-6.36-5.37-8.96-.88-.94-2.05-1.6-3.11-2.36-.23-.17-.6-.45-.77-.37-4.15,1.89-9.1-2.94-12.92,1.54-4.79-2.82-6.15-2.71-9.78.78-3.97-2.88-6.41-3.41-9.71,4.54-2.37-.86-4.68-2.08-7.12-2.47-2.14-.35-4.44.21-6.72,1.16-1.01-1.07-1.98-2.19-3.05-3.2-.54-.51-1.24-1.03-1.94-1.15-2.64-.46-4.36,2.39-7.47,1.73-2.76-.59-4.65,1.69-4.7,4.87,0,.53-.62,1.31-1.14,1.52-3.19,1.32-2.46,3.57-1.42,6.18-2.06,1.98-4.69,4.03-2.48,7.54.06.09.06.31,0,.38-3.35,3.39-1.4,6.04,1.57,8.55-2.36,1.41-5.59,2.2-4.21,5.49,1.18,2.82,4.19,2.03,6.55,1.97,17.86-.47,35.72-1.04,53.58-1.53,11.6-.31,23.2-.52,34.8-.82.66-.02,1.3-.49,1.96-.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M646.03,317.12c4.95,5.21,10,10.34,14.79,15.7,1.13,1.27,1.95,3.33,1.94,5.02-.11,15.89-.52,31.79-.67,47.68-.21,23.19-.39,46.38-.29,69.56.01,3.36.31,6.47-1.66,9.4-1.11,1.65,1.27,4.86-2.37,5.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.81,333.92c-.13,20.45-.2,40.91-.41,61.36-.16,14.98-.5,29.96-.76,44.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.04,334.32c-.26,35.3-.52,70.61-.78,105.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.02,441.01h-87.4v7.82h90.76c.91-3.81,1.9-7.96,2.9-12.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M552.96,194.41c-5.6-4.89-10.91-3.13-16.02.8-3.22,2.49-6.22,5.26-9.41,7.78-29.44,23.21-58.9,46.41-88.38,69.57-12.34,9.69-24.76,19.29-37.15,28.92-.45.35-1.05.5-1.55.8-1.06.63-2.99,1.33-2.97,1.94.08,1.97.42,4.23,1.5,5.8,1.83,2.65,3.56-.37,5.37-.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.94,334.32c.13.65.37,1.3.37,1.95.02,15.63.07,31.26,0,46.9-.07,18.5-.24,37-.39,55.49,0,.52-.24,1.04-.38,1.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 814.97,
    y1: 338.22,
    x2: 814.58,
    y2: 440.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M890.44,204.18h8.14c2.45-13.91-6.05-26.94-17.89-30.57-13.38-4.1-26.95,1.81-33.25,13.77-2.69,5.12-5.07,10.36-4.66,16.56,2.93.23,5.55.43,8.16.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M890.44,517.99c5.78,2.9,12.13,3.85,18.39,4.18,16.28.86,32.59,1.62,48.88,1.52,11.22-.07,22.42-1.66,33.63-2.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.16,514.48c3.91.91,7.79,1.98,11.74,2.7,8.32,1.54,16.68,2.87,25.02,4.34,7.96,1.4,15.91,2.82,23.85,4.3,8.87,1.65,17.73,3.39,26.59,5.06,3.64.69,7.31,1.27,10.94,2,.58.12,1.05.74,1.57,1.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.67,206.52c1.96.13,3.97.58,5.84.24.82-.15,1.79-1.88,1.91-2.98,1.43-12.87-6.23-24.86-16.32-28.6-11.53-4.28-23.22-.35-30.49,9.49-4.58,6.2-7.01,13.21-6.18,21.44,2.08.13,4.3.28,6.53.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.55,495.72c13.17.26,26.33.45,39.5.8,10.69.28,21.38.99,32.07,1.1,17.86.19,35.72,0,53.57.07,10.43.04,20.86.26,31.28.35,1.69.01,3.39-.24,5.08-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.72,569.19c4.17,1.43,8.28,3.12,12.53,4.26,18.35,4.92,36.76,9.62,55.12,14.53,10.2,2.73,20.34,5.71,30.51,8.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M649.16,301.88c-1.43.13-2.87.37-4.3.37-30.37.02-60.74.02-91.12.02s-58.14-.03-87.21.02c-7.56.01-15.12.26-22.68.35-1.3.02-2.61-.24-3.91-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.3,516.82c2.61.91,5.15,2.22,7.83,2.67,11.84,1.98,23.76,3.46,35.56,5.6,15.82,2.87,31.56,6.18,47.32,9.37.48.1.79.99,1.18,1.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.64,575.83c4.82,2.74,10.14,4.88,14.36,8.34,6.5,5.35,12.06,11.77,12.21,20.97.15,9.07-4.77,15.41-11.26,21.16-14.61,12.93-32.6,18.86-50.52,24.9-13.75,4.63-27.87,7.96-42.22,10.19-11.18,1.74-22.43,3.09-33.62,4.74-23.25,3.43-46.65,2.19-70,2.24-8.21.02-16.46-.66-24.63-1.53-22.45-2.41-44.57-6.48-65.7-14.8-9.84-3.88-19.45-8.19-26.56-16.44-1.83-2.12-3.4-4.54-4.69-7.02-3.73-7.21-.69-13.29,3.92-18.69,5.47-6.42,12.37-11.12,19.89-14.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463.41,465.24h26.4v-86.56h-42.04c0,3.7-.12,7.23.04,10.75.1,2.13,1.13,3.84-2.32,4.91-3.56,1.1-4.72,6.88-3.25,10.36.6,1.42.77,3.1.8,4.67.06,3.75,1.42,5.18,5.12,4.65,1.99-.29,3.92-1,5.87-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635.86,390.2c.18-3.78.36-7.55.55-11.53h-42v90.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.49,356.98c-.33,21.88-.66,43.77-.99,66.05,6.33,0,12.07.05,17.81-.01,7.3-.08,14.6-.25,21.9-.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.08,573.88c12.64,3.52,25.3,7.01,37.93,10.56,14.74,4.14,29.46,8.32,44.18,12.53.59.17,1.05.75,1.57,1.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.51,559.81c-3.39,1.56-6.71,3.3-10.18,4.66-21.49,8.4-43.01,16.68-64.5,25.06-2.93,1.14-5.74,2.58-8.61,3.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.04,577.01c5.41,1.3,10.8,2.7,16.23,3.88,5.91,1.28,11.83,2.56,17.8,3.5,7.92,1.24,15.91,2.04,23.84,3.22,3.43.51,6.85,1.32,10.14,2.41,1.13.37,2.11,1.87,2.63,3.08.16.38-1.28,1.89-2.22,2.21-3.2,1.1-6.45,2.41-9.76,2.7-8.05.71-16.16,1.33-24.23,1.17-10.96-.22-21.95-.77-32.84-1.95-14.96-1.61-29.86-4-43.77-10.15-4.3-1.9-8.12-4.86-12.16-7.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M951.06,488.29c-11.34-.78-22.68-1.59-34.02-2.33-5.08-.33-10.17-.54-15.25-.79-10.69-.53-21.38-1.04-32.07-1.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M544.35,341.74c-.13,3.65-.34,7.29-.37,10.94-.06,7.17-.02,14.33-.02,21.69h47.32v-32.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.12,549.26c.67-2.68-1.11-3.73-3.14-4.27-8.19-2.16-16.33-4.64-24.65-6.18-10.87-2.01-21.86-3.38-32.84-4.69-2.65-.32-5.59.29-8.18,1.14-9.94,3.24-20.3,3.67-30.52,5.02-21.44,2.83-43,1.82-64.53,1.91-6.19.03-6.14-.15-8.23,5.89-1.6,4.61-4.05,8.87-4.08,14.07-.01,2.09-2.23,4.13-3.29,6.27-.47.94-.56,2.07-.82,3.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.84,341.74v32.63h-46.93v-32.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M850.95,237.79c-1.43.14-2.87.29-4.69.47v7.35h51.82v-7.43h-46.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M982.73,487.9c-3.52.52-7.03,1.17-10.56,1.54-7.16.74-14.33,1.77-21.51,1.9-25.38.47-50.71-.4-75.87-4.2-2.46-.37-4.95-.54-7.43-.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.21,472.27c-4.52,3.53-9.97,1.55-14.89,2.1-11.51,1.29-23.18,1.78-34.78,1.67-10.83-.11-21.66-1.23-32.44-2.38-1.84-.2-4.83,2.49-6.13-2.26,2.53-.74,5.06-1.92,7.68-2.17,10.02-.97,20.06-1.67,30.11-2.4,2.2-.16,4.43-.02,6.65-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.37,337.44c.13-4.69.23-9.38.4-14.07.23-6.12.44-12.25.8-18.37.27-4.7.79-9.38,1.1-14.07.03-.44-.57-.92-1.34-2.07-2.55,9.55-4.68,18.38-7.28,27.07-2.58,8.63-.72,17.2-.37,25.81.29,7.16.18,14.33.46,21.49.19,4.96.74,9.9,1.14,14.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.6,537.93c7.3,1.69,14.64,3.23,21.89,5.12,9.43,2.45,18.69,5.57,28.19,7.65,7.66,1.68,15.54,1.78,23.02-1.52.87,3.3.06,5.16-3.51,5.43-5.83.45-11.73.29-17.59.05-3.14-.13-6.26-.97-9.39-1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.19,542.22c-5.35-.82-10.07,1.58-14.83,3.21-9.75,3.36-19.39,7.04-28.95,10.9-9.16,3.7-17.72,1.69-26.21-2.02-1.49-.65-2.88-1.54-4.31-2.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.44,603.58c-7.27,5.99-16.17,7.43-25.04,8.49-6.71.8-13.56,1.06-20.32.78-8.55-.36-17.02-1.66-24.25-6.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M938.93,440.22h32.07c7.95,0,15.9-.04,23.85.02,3.15.02,2.29,2.52,2.31,4.28.02,1.67.82,4.01-2.31,3.91-.78-.02-1.56,0-2.35,0-15.12,0-30.24-.03-45.36.02-4.22.01-8.49-.53-12.56,1.45-.85.41-2.3-.42-3.47-.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M639.77,605.54c-6.78,1.82-13.53,3.78-20.34,5.44-14.19,3.47-28.41,6.78-42.61,10.21-2.12.51-4.18,1.28-6.26,1.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M592.85,579.74c-7.56,1.17-15.11,2.4-22.68,3.5-6.77.99-13.55,1.86-20.33,2.75-8.21,1.07-16.43,2.07-24.63,3.17-.56.08-1.05.74-1.57,1.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.12,560.98c-19.03,5.6-38.07,11.17-57.09,16.83-3.83,1.14-7.57,2.58-11.35,3.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.95,241.3c-2.36.19-4.71.37-7.43.59,0,1.11.09,2.03-.02,2.93-.37,3.03.9,4,3.93,3.97,12.25-.14,24.51-.06,36.76-.06h10.95c0-1.81-.26-3.31.06-4.68.61-2.59-.48-3.19-2.79-3.16-13.56.18-27.11.28-40.67.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.19,192.45c-11.36-5.47-25.05,1.28-27.19,14.49-1.26,7.78-.74,15.86-.95,23.81-.09,3.38-.02,6.77-.02,10.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.99,357.37c-.13,6.25-.26,12.51-.39,18.76-.02.91,0,1.82,0,2.74,0,13.55-.04,27.1.02,40.64.02,5.86.24,11.72.37,17.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.5,357.37c-.13,1.43-.37,2.87-.37,4.3-.02,20.19-.02,40.38-.02,60.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.95,357.37c.13,1.43.37,2.87.37,4.3.02,20.19.02,40.38.02,60.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M683.18,620.39c-12.64,3.91-25.25,7.95-37.95,11.68-8.79,2.58-17.71,4.74-26.58,7.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M641.34,322.98c-.26,4.82-.65,9.64-.76,14.46-.22,9.77-.29,19.54-.41,29.31-.03,2.34,0,4.69,0,7.03,0,19.93.04,39.86-.02,59.79-.03,9.9-.25,19.8-.37,29.7-.04,3.14.22,5.36,4.19,6.91,4.86,1.89,8.97,5.73,13.4,8.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M458.71,420.68h-10.75v44.16h10.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M552.18,205.74c0,5.08.03,10.16,0,15.24-.12,20.71-.27,41.43-.35,62.14,0,1.17.49,2.34.75,3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M538.88,206.52c.13,4.69.28,9.38.38,14.07.05,2.21.03,4.43,0,6.64-.25,19.8-.53,39.6-.77,59.4-.06,4.95,0,9.9,0,14.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M883.79,237.79c.13-3,.42-6,.36-8.99-.18-8.99.23-18.07-.95-26.94-1.24-9.36-10.31-16.02-20.13-14.05-.85.17-1.57,1-2.36,1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.04,532.85c-7.95-1.3-15.91-2.58-23.85-3.91-9.13-1.53-18.25-3.14-27.38-4.67-3.51-.59-7.04-1.05-10.56-1.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 753.97,
    y1: 360.5,
    x2: 753.97,
    y2: 422.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M971.78,360.11v61.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M924.86,476.96c-3.39.13-6.78.4-10.17.37-14.84-.16-29.58.95-44.18,3.6-2.13.39-4.12,1.52-5.92,2.21,1.16,2.32,1.97,3.93,2.78,5.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.81,577.4c-1.3-.91-2.48-2.28-3.93-2.67-17.83-4.8-35.7-9.45-53.56-14.13-.64-.17-1.3-.27-1.95-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.76,539.88c-7.69-1.43-15.39-4.05-23.07-3.97-7.84.08-15.7,2.57-23.45,4.43-8.02,1.93-15.93,4.33-23.86,6.61-1.5.43-3.01,1.08-4.28,1.96-2.44,1.68-2.75,4.36-.78,6.57.97,1.09,2.21,2.03,3.5,2.74,8.88,4.86,18.18,5.92,27.73,2.32,4.41-1.66,8.56-4.01,12.95-5.75,2.21-.88,4.44-1.07,7.06-.21,5.44,1.79,11.16,2.75,16.77,4.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M624.91,593.03c13.04,6.12,25.95,12.52,39.14,18.3,16.43,7.2,33.08,13.88,49.63,20.79.54.22,1.04.52,1.57.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.99,563.72c-6.65,2.87-13.28,5.77-19.95,8.59-11.46,4.85-22.95,9.62-34.39,14.51-1.16.5-2.1,1.53-3.14,2.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.38,549.65c-3.39-.91-6.75-1.95-10.17-2.71-13.15-2.92-26.32-5.8-39.5-8.58-2.55-.54-5.21-.56-7.81-.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.38,568.02c-5.98,4.8-12.17,9.32-19.57,11.69-9.07,2.9-18.13,5.98-27.39,8.12-9.78,2.26-19.73,3.95-29.71,5.08-8.92,1.01-17.97,1.18-26.97,1.16-3.13,0-6.25-1.72-9.39-2.57-1.89-.51-2.21-1.93-2.34-3.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.46,326.11c.26,3.91.73,7.82.75,11.72.08,17.98.03,35.95.07,53.93,0,.78.49,1.56.75,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1015.19,521.12c-.13,7.56-.33,15.11-.35,22.67,0,2.58-.97,3.71-3.56,3.53-2.6-.18-5.22-.22-7.82-.42-2.1-.16-3.25-1.02-3.19-3.5.17-6.9,0-13.81.09-20.71.03-2.3-.36-3.39-3.15-3.65-4.39-.41-8.04-2.72-10.57-6.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635.47,417.17c-3.25.15-6.5.3-9.76.44-.24-.3-.47-.59-.71-.89,1.2-1.85,2.4-3.69,3.68-5.66-.73-1.36-1.22-3.72-3.81-1.35-.83.76-2.03,1.14-3.1,1.59-2.28.95-2.11,2.49-1.18,4.31,1.72,3.36,1.45,6.88,1.28,10.55-.42,8.84-.37,17.71-.48,26.57-.05,4.04,0,8.08,0,12.11h-26.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.84,414.04c-.68-.34-1.36-.68-2.04-1.02-1.38,2.49-1.68,24.01.43,28.32.54-1.28,1.51-2.56,1.54-3.85.36-16.93.58-33.87.86-50.8.04-2.48.25-4.95.38-7.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M977.26,492.2c1.17-.52,2.31-1.16,3.53-1.54,2.39-.73,3.32-2.7,2.95-4.68-.21-1.09-2.05-2.38-3.37-2.68-6.47-1.5-12.96-3.17-19.54-3.89-9.86-1.08-19.8-1.41-29.71-2.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.6,536.75c-.65.52-1.23,1.31-1.97,1.52-14.98,4.22-29.98,8.34-44.95,12.59-2.17.62-4.18,1.78-6.27,2.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M747.71,669.63c-6.91-2.87-13.8-5.78-20.73-8.59-11.06-4.47-22.16-8.87-33.24-13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M538.49,222.55c-12.25,9.77-24.47,19.59-36.77,29.3-15.08,11.91-30.27,23.67-45.33,35.6-5.73,4.54-11.18,9.41-16.88,13.99-.98.79-2.56,1.18-3.87,1.17-8.86-.03-17.73-.28-26.59-.29-2.32,0-4.58.59-4.32,3.86.23,2.99-.38,6.24.61,8.91.86,2.31,3.45,3.98,5.27,5.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.63,414.43c-.13,1.69-.37,3.39-.37,5.08-.03,14.59,0,29.18-.05,43.77,0,1.43-.49,2.87-.75,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M629.21,411.3c2.24.28,4.47.57,6.45.82v53.11h-9.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.32,326.89c-.78,4.17-1.31,8.4-2.4,12.49-2.53,9.53-2.3,19.22-2.36,28.93-.02,3.65-.72,7.3-1.11,10.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M564.69,537.53c-14.21-.13-28.42-.31-42.63-.35-3,0-6,.48-8.99.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M669.88,302.27c-5.87.13-11.73.31-17.6.34-.91,0-1.98-.54-2.71-1.14-16.98-14.03-33.89-28.14-50.87-42.17-10.78-8.91-21.6-17.77-32.47-26.56-4.33-3.51-8.85-6.79-13.28-10.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.08,322.59c1.33.29,2.65.58,3.92.86-.86,2.25-2.23,4.2-2.25,6.17-.12,8.46-.15,16.95.38,25.39.43,6.8,1.7,13.56,2.68,20.32.14.95.75,1.83,1.14,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.5,498.45c-.39.52-.68,1.35-1.19,1.52-16.54,5.53-33.09,10.99-49.65,16.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M971.39,493.37c3.65-3.06,7.3.14,10.95.14,6.65.01,13.29.97,19.95,1.4,5.86.37,11.73.57,17.6.8,7.3.29,14.61.38,21.9.83,7.96.48,15.9,1.29,23.86,1.9,2.99.23,6,.36,8.99.35.78,0,1.83-.53,2.29-1.15,1.08-1.44,2.07-3.01,2.72-4.68.39-1.02.56-2.79-.02-3.4-1.46-1.51-1.27-2.91-1.27-4.78,0-1.77-1.57-3.55-2.51-5.44.49-.58,1.32-1.58,2.05-2.45-.34-2.54-3.46-3.15-2.5-6.68.67-2.45-3.66-3.37-6.86-2.88-.42-3.34-1.84-5.24-5.65-4.54-1.44.26-3.09-.87-4.68-1.01-1.54-.13-3.27-.16-4.66.41-3.06,1.25-5.88,3.39-9.42,1.5-.2-.11-.6-.12-.76,0-2.76,2.19-5.98,4.04-8.06,6.75-1.5,1.96-1.49,5.08-2.1,7.69-.12.49.17,1.4-.04,1.51-3.44,1.76-2.23,4.47-1.54,7.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.33,325.33c2.35.52,4.67,1.18,7.05,1.5.99.13,2.15-.3,3.11-.74,2.96-1.36,8.29-.87,10.53,1.24.53.5.84,1.54.78,2.3-.72,8.86-1.36,17.74-2.35,26.57-.79,7.06-2.03,14.07-3.08,21.11-.12.78-.61,1.73-.33,2.32,2.25,4.79-2.03,4.27-3.96,4.16-3.55-.2-7.14-1.12-10.54-2.26-2.85-.96-4.71-1.41-6.39,1.99-2.17,4.38-5.26,8.3-7.68,12.58-3.03,5.38-6.03,10.81-8.57,16.42-2.66,5.88-1.42,8.87,4.23,12.47,3.86,2.46,9.48,2.04,13.32-.75,3.01-2.19,6.14-2.43,9.79-.9,6.2,2.6,7.31,7.6,7.4,13.38.1,6.12.25,12.25.38,18.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.94,512.52c3.78-.39,7.55-.89,11.34-1.12,1.41-.08,2.88.4,4.3.74,3.66.87,7.27,1.95,10.96,2.7,10.67,2.16,21.37,4.23,32.07,6.25,2.31.44,4.69.55,7.03.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.5,353.47h76.45v-16.22h-76.92c-.38,33.54-.75,66.89-1.12,100.24h75.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.68,605.54c0,11.72.03,23.45-.02,35.17-.02,4.04-.24,8.08-.37,12.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.55,508.22c6.78,0,13.56-.2,20.33.06,5.62.22,11.21.98,16.82,1.5,5.61.52,11.22.99,16.81,1.61.95.11,1.83.86,2.74,1.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.5,240.13c.13-12.51.26-25.01.39-37.52.03-2.93-.37-5.56-2.63-7.91-1.22-1.27-.98-3.89-2.13-5.31-5.16-6.39-15.44-7.69-22.51-3.03-5.77,3.81-8.77,9.83-9.57,17.03-1.4,12.51-.26,25.02-.7,37.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.33,509.27s57.61,11.33,64.52,12.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.16,512.91c3.39.65,46.95,9.65,56.3,11.39,3.59.67,7.03,2.12,10.59,3,1.08.27,2.42.03,3.49-.38,2.4-.9,4.71-2.04,7.06-3.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.38,598.89c-.13,13.29-.26,26.57-.39,39.86-.02,2.34,0,4.69,0,7.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.12,542.22c-7.04,1.82-14.14,3.46-21.1,5.52-8.53,2.53-16.96,5.42-25.43,8.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M889.66,237.79c0-12.51.08-25.01-.03-37.52-.07-7.36-3.23-13.05-9.73-16.82-6.45-3.75-12.41-2.6-18.43,1.13-2.09,1.29-3.87,2.37-3.48,5.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M598.32,259.67c-13.3,11.72-26.59,23.45-39.89,35.17-1.94,1.71-3.91,3.39-5.86,5.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.13,259.67c13.56,12.25,27.1,24.5,40.69,36.72,1.31,1.18,2.85,2.1,4.29,3.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M976.87,486.73c-7.82-.26-15.65-.41-23.46-.81-7.05-.36-14.08-1.01-21.12-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M750.44,618.04c-4.69,2.34-9.28,4.93-14.1,6.99-15.85,6.76-31.69,13.59-47.73,19.88-10.23,4.01-20.81,7.17-31.25,10.63-4.26,1.41-8.6,2.62-12.9,3.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M625.3,417.95c-.26,1.82-.77,3.65-.74,5.47.19,13.81.49,27.62.72,41.43.02,1.17-.24,2.34-.37,3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463.41,417.95c-.39,1.56-1.12,3.13-1.12,4.69.04,12.9.19,25.79.35,38.69.03,2.35.25,4.69.38,7.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M933.07,526.98c.13,6.51.34,13.03.27,19.54,0,.66-1.77,1.91-2.6,1.82-1.44-.16-3.78.45-3.92-2.21-.28-5.47-.62-10.94-.7-16.41-.01-.9,1.21-1.82,1.86-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.37,383.56c3.65,9.38,7.3,18.76,10.95,28.14.81,2.08,1.58,4.16,2.35,6.25,1.64,4.44,1.19,7.1-2.8,8.85-4.15,1.82-8.28,4.45-13.24,3.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M831.39,508.22c6.52,1.43,12.98,3.25,19.57,4.18,5.26.74,10.67.32,16.02.54,2.61.11,5.22.49,7.82.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M464.19,412.09c-.81-1.02-1.63-2.03-2.46-3.08-2.62,1.12-4.28,3.9-3.33,6.96,1.49,4.79,1.09,9.63,1.09,14.48.02,9.64.04,19.28-.03,28.92-.01,1.57-.49,3.13-.75,4.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.84,440.61c.13,9.51.28,19.02.38,28.53.05,4.69,0,9.38,0,14.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M525.19,551.99c-.52.13-1.04.36-1.56.38-9.25.28-18.51.45-27.76.83-4.44.18-8.87.75-13.3,1.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M922.9,482.82c-14.08-.26-28.16-.52-42.23-.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.38,382.78c-4.17,10.16-8.45,20.28-12.45,30.51-1.42,3.63-2.15,7.53-3.19,11.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.38,471.88c-1.87-4.18-5.9-4.01-9.39-4.22-10.28-.61-20.59-.86-30.89-1.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.54,497.28c-4.43.39-8.86.77-13.3,1.18-.92.08-2.16.7-2.68.31-3.7-2.74-7.61-.54-11.39-.78-5.75-.37-11.52-.99-17.2-1.95-4.88-.82-9.66-2.27-14.48-3.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M579.55,517.6c-4.17.26-8.34.58-12.51.77-9.38.43-18.77.79-28.16,1.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M715.25,458.59c-.93-3.15-3.15-4.23-6.23-3.84q-1.88-5.48-5.89-4.76c-1.72-4.42-3.87-4.78-9.39-1.56-3.71-4.59-7.09-5.65-10.16.38-3.03,1.06-5.43,1.9-7.83,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.07,591.08c-.13.91-.35,1.82-.38,2.74-.28,11.72-.53,23.45-.81,35.17-.02.65-.25,1.3-.38,1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.03,326.5c-4.18-.34-2.67-2.96-1.93-5.07,2.41-6.93,4.92-13.82,7.41-20.72,1.28-3.53,2.52-7.07,3.93-10.54,1.01-2.48,2.35-4.95,5.45-5.05,4.45-.14,6.94,1.5,8.15,5.83,2.29,8.15,4.24,16.4,6.31,24.61.32,1.29.44,2.63.81,3.9,1.61,5.54,1.14,6.73-3.93,9.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.59,338.61v39.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.11,385.9c-.71,6.71-.56,13.32,1.08,19.95.81,3.25.71,6.75.85,10.14.13,3.25.03,6.51.03,9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M944.8,519.56c-8.34-.78-16.68-1.71-25.03-2.29-4.67-.32-9.38-.06-14.07-.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M591.67,254.2c-10.95,9.38-21.9,18.76-32.85,28.14-.42.36-.72.96-1.19,1.14-7.57,2.96-5.76,9.48-5.84,15.27-.01,1.04.24,2.08.37,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M931.5,377.7c1.27,10.53,3.14,21.04.74,31.85h-9.17c-.48-2.3-.91-4.37-1.34-6.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500.56,253.42c8.47,7.69,16.9,15.42,25.44,23.04,3.93,3.51,8.06,6.79,12.1,10.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.66,600.06c3.53,7.17.45,9.52-7.49,12.75-6.25,2.55-12.98,4-19.89,4.09-2.87.04-5.73.54-8.6.73-8.11.54-15.98-1.17-23.85-2.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M570.16,564.11c-9.78,1.04-19.57,1.98-29.33,3.15-12.01,1.45-23.99,3.08-35.98,4.7-.95.13-1.83.75-2.74,1.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M640.16,470.71c-1.17.26-2.34.73-3.52.75-11.21.18-22.42.35-33.63.34-1.17,0-2.35-1.22-3.52-1.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M656.59,580.13c-2.74,3.04-6.74,2.61-10.19,3.43-7.88,1.85-15.89,3.2-23.83,4.81-.95.19-1.83.75-2.74,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.29,386.68c-1.96,11.59-3.92,23.19-5.83,34.79-.12.74.23,1.56.36,2.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "852.12 221.37 865.22 221.37 865.22 210.04 852.12 210.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M701.95,601.24c-11.34,3-22.68,6-34.03,8.98-.89.23-1.82.27-2.73.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M907.65,471.88c-3.5-4.13-4.52-4.39-9.55-2.27-1.88-3.91-3.78-7.93-9.22-7.52-.25.02-.54-.21-.78-.38-6.38-4.45-10.41-3.94-15.34,2.06-.46-.15-1.04-.22-1.47-.51-.83-.58-1.5-1.65-2.38-1.85-1.77-.4-3.71-.07-5.44-.54-1.86-.51-3.47-2.06-5.55-.38-.41.33-1.74.07-2.25-.37-2.48-2.11-4.83-1.18-6.16.91-1.19,1.87-2.31,2.39-4.38,2.86-1.67.38-2.73,2.96-4.4,4-1.65,1.02-4.34.02-5.39,2.44-.42.97-.55,2.07-.81,3.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M933.85,510.18c2.49,3.5,5.48,5.41,10.17,5.19,10.15-.48,20.36-.85,30.49-.3,5.15.28,10.23,2.52,15.22,4.22,1.06.36,1.6,2.23,2.39,3.4-1.04.65-2.04,1.78-3.14,1.88-7.42.67-14.85,1.29-22.29,1.59-6.25.25-12.51.02-18.77.09-.78,0-1.56.49-2.35.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M414.91,248.73c-.13,11.59-.29,23.19-.37,34.78-.02,2.34.24,4.69.37,7.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M437.99,520.34c5.87.52,11.72,1.15,17.6,1.53,6.12.4,12.25.55,18.38.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M442.29,488.29c4.69.26,9.38.61,14.08.76,6.78.21,13.58.63,20.32.24,2.8-.16,5.49-2.15,8.21-3.39.26-.12.42-.76.39-1.13-.4-5.08,1.17-10.31-1.15-15.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M820.05,473.44c-2.17-8.17-6.81-10.84-15.64-7.81-1.69-2.44-3.65-3.61-6.66-1.99-3.84,2.08-7.81,3.94-11.72,5.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M984.69,517.6c-3.54,3.73-8.07,1.52-12.13,1.85-2.96.25-5.98-.57-8.99-.65-4.69-.13-9.38-.03-14.08-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.11,333.92c.13,7.56.28,15.11.38,22.67.05,3.65.05,7.3-.03,10.94-.01.66-.49,1.3-.75,1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M619.05,562.55c-6.91,1.3-13.81,2.63-20.73,3.9-3.9.71-7.84,1.19-11.72,2.01-2.47.52-4.5.57-6.7-1.16-5.86-4.6-11.95-8.92-17.94-13.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.88,604.75c-.39,12.9-.82,25.79-1.14,38.69-.05,2.07-.74,3.17-2.75,3.97-4,1.6-7.78,3.74-11.78,5.36-3.91,1.59-7.02-.77-7.02-5.04,0-9.38.12-18.76-.05-28.14-.08-4.43-.73-8.86-1.12-13.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.19,289.76c2.09,10.03,4.18,20.06,6.24,30.1.13.62.1,1.31,0,1.95-.37,2.57.88,3.17,3.15,2.77.48-.08,1.04.23,1.56.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.28,540.66c-3.91,10.68-7.83,21.36-11.72,32.05-.37,1-.54,2.08-.8,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.66,550.82c7.43,1.69,14.88,3.32,22.28,5.11,4.21,1.02,8.35,2.32,12.52,3.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.07,471.88c2.61.13,5.21.33,7.82.38,8.99.16,17.99.38,26.98.31,1.83-.01,3.65-1.21,5.48-1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.67,566.06c6.39-1.85,12.79-3.64,19.45-3.76.2.48.39.96.59,1.43-2.51,1.43-4.88,3.22-7.55,4.21-6.83,2.56-13.92,4.45-20.66,7.21-4.62,1.9-9.19,3.69-14.12,4.6-7.97,1.48-15.94,2.95-23.84,4.73-4.12.93-8.1,2.54-12.14,3.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M596.76,551.21c-7.04.52-14.07,1.14-21.12,1.54-8.86.5-17.73.81-26.59,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M932.09,514.48c-3.58.13-7.17.39-10.75.37-8.6-.05-17.22-.49-25.81-.22-2.71.09-6.39.85-5.73,6.16,2.05.68,4.43,1.96,6.91,2.16,2.62.21,2.36,1.53,2.35,3.26-.04,7.82-.05,15.63.03,23.45,0,.66.63,1.77,1.14,1.87,2.27.47,5.77-2.58,5.82-5,.04-1.83.69-2.87,2.32-3.99,5.89-4.08,11.53-8.51,17.27-12.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.73,480.87c-4.92-.76-9.85-1.51-15.73-2.42-1.13-1.98-3.2-4.7-7.3-2.99-3.67-5.78-4.47-6.06-7.86-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M773.12,340.96v15.63h-33.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480.22,536.75c4.3.13,8.6.3,12.91.38,3.13.06,6.31.39,9.37-.06,7.13-1.06,12.42,1.33,16.04,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.54,388.64c-.13,1.69-.36,3.39-.37,5.08-.05,5.34-.66,10.78.14,16,1.06,6.97-1.37,12.81-4.05,18.79-1.84,4.11-.69,5.76,3.88,6.69,3.38.69,7.17,1.07,8.22,5.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.81,488.68c-.91.52-1.82,1.49-2.74,1.49-5.12.01-10.02,2.64-15.25,1.26-2.2-.58-4.55-.76-6.62-1.63-6.4-2.68-12.93-2.95-19.56-1.43-1.67.38-4.4.69-3.15,3.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.66,642.27c-9.39,6.9-18.8,13.77-28.12,20.76-1.29.97-2.12,2.56-3.16,3.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.74,538.32c2.87,10.68,5.74,21.36,8.6,32.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.42,437.1v-99.85h-75.67v100.24h78.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M985.86,526.2c-.13,7.03-.16,14.07-.46,21.1-.08,1.84-.41,4.48-1.61,5.3-2.57,1.76-5.33-.06-7.67-1.44-2.24-1.32-1.09-3.52-.81-5.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.59,357.37c.13,1.3.37,2.61.37,3.91.02,19.41.05,38.82,0,58.23-.01,5.73-.24,11.46-.37,17.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.36,356.98c-.26,26.71-.52,53.41-.78,80.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M849.38,515.65c4.43.13,8.86.29,13.3.38,3,.06,6.01-.18,8.99.07,2.83.24,3.94-.92,3.58-4.37-1.14-2.7-4.51-2.66-7.47-3.55-3.71-1.11-7.45-2.27-10.93-3.93-6.58-3.14-13.15-3.74-19.97-1.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.73,357.37v64.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.88,445.3c1.55.16,3.09.32,4.82.5,2.43-12.62-2.14-24.2-3.34-36.03.46-.13.91-.26,1.37-.39.61,1.55,1.34,3.07,1.82,4.66,1.87,6.24,3.79,12.47,5.46,18.76,1.19,4.5,1.01,4.58-3.87,6.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M922.51,378.09c.52,1.04,1.42,2.06,1.5,3.13.4,5.2.56,10.42.85,15.63.23,4.04.51,8.08.77,12.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.45,562.16c.19-3.12.38-6.25.57-9.2-5.74-3.64-11.17-.79-16.59.25-7.58,1.44-15.13,3.1-22.69,4.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.08,357.37c-.13,1.43-.37,2.87-.37,4.3-.02,20.19-.02,40.38-.02,60.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M739.1,337.44c-.13,17.07-.29,34.13-.38,51.2-.06,11.98-.01,23.97-.01,35.95v15.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M964.74,517.6c-10.04-.13-20.07-.26-30.11-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.59,636.41c1.04,9.38,2.09,18.76,3.12,28.14.07.64,0,1.3,0,1.95"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 750.84,
    y1: 360.5,
    x2: 750.84,
    y2: 422.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.36,376.91c-.52,8.34-.99,16.68-1.6,25.01-.18,2.49-.75,4.95-1.14,7.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.05,354.64c.65,6.77,1.8,13.55,1.81,20.32.01,6.38-1.31,12.76-1.76,19.15-.29,4.15-.05,8.33-.05,12.66-2.22.89-4.82,1.17-7.43-.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 797.76,
    y1: 359.72,
    x2: 797.76,
    y2: 422.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 797.76,
    y1: 340.95,
    x2: 797.76,
    y2: 356.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 974.77,
    y1: 359.72,
    x2: 974.77,
    y2: 421.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.91,631.33c-4.95.78-9.89,1.73-14.86,2.31-9.89,1.16-19.8,2.3-29.72,3.09-5.31.42-10.69.24-16.03.03-5.18-.2-10.15-.1-14.08,3.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.31,414.04c-1.04-1.4-2.24-1.17-2.27.39-.16,8.07-.13,16.15-.03,24.23.02,1.64.94,2.28,2.3.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M865.41,190.89v16.41h-13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M895.53,523.47c-.13,8.08-.25,16.15-.4,24.23-.04,2.45,1.78,2.73,3.52,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M661.28,249.9c.52,2.61,1.41,5.2,1.49,7.82.22,6.51.09,13.02.04,19.54,0,.52-.49,1.04-.75,1.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.71,612.18c8.86,2.87,17.73,5.74,26.6,8.58.75.24,1.56.27,2.34.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.24,194.8v16.02h-13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.59,194.02v17.36c4.43-.2,8.47-.38,12.51-.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.08,495.72c-12.33,2.02-24.69,3.12-37.15,1.8v9.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M506.81,507.83c-1.56,2.74-2.55,6.31-4.88,7.93-1.78,1.24-5.28,0-8.02-.11-3.91-.15-7.82-.27-11.73-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M938.05,392.94c-.25-5.11-1.41-10.18-2.3-15.24-.17-.97-.99-1.83-1.51-2.74-.65.52-1.23,1.23-1.97,1.53-1.75.71-3.58,1.23-5.35,1.81.35,9.42.71,19.07,1.06,28.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.84,375.74c.26,8.73.54,17.46.75,26.18.02.64-.49,1.3-.75,1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.54,410.52c0,8.08.03,16.15-.04,24.23-.01,1.3-.49,2.61-.75,3.91"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 934.12,
    y1: 356.99,
    x2: 988.59,
    y2: 356.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 954.19,
    y1: 341.74,
    x2: 954.2,
    y2: 356.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M978.82,546.52c-4.95-2.87-9.86-5.82-14.87-8.57-5.42-2.97-10.94-5.76-16.41-8.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.18,472.66c-12.39,1.33-24.56-.73-36.76-2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M755.53,494.16c.39-.91.85-1.8,1.15-2.74.24-.75.56-2.16.37-2.25-3.03-1.4-1.6-6.77-6.21-6.88-.68-.02-1.52-1.87-1.92-3-1.16-3.35-3.38-4.62-7.09-3.92-.48.09-1.04-.23-1.56-.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.95,610.22c-9.26.65-18.51,1.3-27.77,1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.08,602.41c9.12.26,18.25.52,27.37.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M938.15,440.61c-.39-4.43-.66-8.87-1.21-13.28-.53-4.3-2.35-8.35-1.62-12.91.77-4.76.84-9.63,1.27-14.45.19-2.09,1.45-7.03,1.45-7.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.01,497.67c-.13,5.21-.23,10.42-.41,15.63-.07,2.03,1.08,2.63,2.75,2.31,1.86-.36,3.68-.95,5.45-1.62.14-.05-.22-1.47-.35-2.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.43,581.7c-5.61,2.21-11.23,4.39-16.81,6.66-3.3,1.34-6.52,2.85-9.78,4.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.94,558.25c-10.82,3-21.66,5.92-32.45,9.01-9.16,2.62-18.26,5.42-27.38,8.19-4.97,1.51-9.91,3.12-14.86,4.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M873.63,509.01c11.73-.55,23.45-1.22,35.2-.05,4.4.44,8.86.31,13.29.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M926.03,413.65c-.78,8.99-1.56,17.98-2.35,26.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M930.33,413.65c.52,7.3.99,14.59,1.6,21.88.14,1.71.75,3.39,1.14,5.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.19,376.13c.39.52,1.13,1.04,1.12,1.56-.06,8.47-.2,16.94-.36,25.4-.01.78-.25,1.56-.38,2.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.45,350.73c-1.04-.13-2.09-.26-3.13-.39.48-1.13.97-2.26,1.45-3.39.31.02.62.05.93.07,1.29,3.32,2.93,6.55,3.8,9.98,1.23,4.87,1.94,9.87,2.81,14.83.73,4.15.14,4.7-3.9,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M739.49,437.49h70.78l1.17-97.31-71.56-.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448.55,390.2c2.38-2.42,5.07-3.17,8.37-1.72q3.28-3.42,8.08-.65c.39.23,1.03.03,1.55.03.78,0,1.72-.28,2.32.05,2.16,1.17,4.05,3.19,6.32,3.71,3.34.77,3.64,2.27,3.27,5.25-.16,1.3,1.91,2.74,2.5,4.3,1.31,3.43-.64,6.21-4.24,7.07-3.96.95-7.98,1.97-11.66,3.65-1.18.54-1.37,3.27-2.26,5.68h26.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.38,279.6c-4.04-8.08-8.06-16.16-12.16-24.21-.35-.68-1.26-1.06-1.91-1.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "865.41 237.79 865.41 223.72 852.12 223.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M880.67,223.72h-12.9v14.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M934.63,412.48c-2.22.13-4.44.45-6.65.34-2.12-.1-4.22-.65-7.08-1.12-1.25,3.09-2.82,6.8-4.24,10.56-1.27,3.35-2.33,6.78-3.55,10.15-1.26,3.46-.91,4.32,2.36,5.48,2.49.88,4.96,1.82,7.43,2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M489.22,421.07c-8.73-.13-17.47-.26-26.2-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M739.1,475.79c1.63-1.95,1.78-4.06-.03-5.83-3.03-2.95-6.42-1.87-10.32-.17,1.79-5.09-3.58-6.57-4.62-10.38-.73-2.64-3.62-2.18-5.73-1.9-1.24.17-2.36,1.21-3.53,1.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.6,511.74c1.16,2.84,3.65,1.62,5.47,1.48,7-.55,13.59,1.3,19.9,3.74,4.51,1.74,3.71,8.51-1.14,11.16-3.42,1.87-7.02,3.42-10.54,5.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.57,440.22c-.78.13-1.56.28-2.35.39-2.08.27-4.73-.13-6.07,1.01-.97.82-.13,3.69-.2,5.64-.23,6.12-.51,12.25-.79,18.37-.01.27-.42.69-.35.76,1.17,1.22-1,4.16,1.93,4.26,2.8.09,1.71-2.72,1.8-3.85.56-7.01.77-14.06.84-21.09.01-1.17-1.21-2.34-1.86-3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M621.39,420.68c-8.6.13-17.21.26-25.81.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M930.72,480.48c8.6.52,17.21,1.04,25.81,1.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M924.07,412.87c-1.56,8.08-3.07,16.16-4.72,24.22-.74,3.62-2.48,7.12-1.15,10.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863.85,516.82v22.57c-2.2.18-4.16-.02-5.84.56-3.31,1.15-4.33-.69-4.26-3.2.19-6.91.71-13.81,1.1-20.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M929.55,519.17c-6-.13-11.99-.28-17.99-.38-2.48-.04-4.95,0-7.43,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.71,228.41h-28.55v12.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.84,598.89c-3,3.65-5.98,7.31-9,10.94-1.53,1.85-3.49,3.46-4.56,5.54-.77,1.5-.39,3.58-.52,5.41,1.69,0,3.41.14,5.08-.05,1.07-.12,2.09-.73,3.13-1.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M838.04,514.48c-.26,5.47-.51,10.94-.79,16.41-.11,2.23.91,3.38,3.13,3.1,2.73-.35,6.53,1.68,7.43-3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.98,424.59c-1.82,7.82-3.75,15.61-5.39,23.47-.33,1.57.44,3.37.7,5.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M620.61,417.56h-25.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.32,370.27c.39,4.69.91,9.37,1.14,14.07.27,5.73.18,11.47.46,17.19.2,4.18,1.17,8.35,1.02,12.5-.16,4.58-1.17,9.13-1.85,13.68-.35,2.35-.77,4.69-1.17,7.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M660.5,486.34c5.74-.13,11.47-.22,17.21-.41,3.14-.1,4.3.9,4.28,4.31-.03,4.69-.27,9.38-.34,14.07-.02,1.3.24,2.61.37,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.07,557.08c3.13-1.17,6.2-2.54,9.4-3.48,5.82-1.71,11.71-3.2,17.59-4.7,1-.25,2.11-.04,3.52-.04.02,2.06-.52,2.76-2.34,3.19-6.56,1.53-13.06,3.29-19.56,5.05-.98.27-1.83,1.01-2.75,1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.24,225.28v-11.72h-13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.82,531.67c-3.39-1.04-41.98-7.99-44.19-8.23-2.75-.3-5.48-.76-8.21-1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.42,618.04c-6.52.52-13.03,1.08-19.56,1.53-1.42.1-2.87-.23-4.3-.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.9,578.57c.13,2.34.36,4.69.37,7.03.05,7.56.02,15.11.02,22.67,0,3.16-2.73,5.91-5.86,5.85-.65-.01-1.3-.31-1.96-.36-7.61-.67-8.89-2.41-7.43-10.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.12,491.81c-5.08.39-10.17,1.06-15.25,1.06-2.7,0-5.78,1.46-8.21-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M385.19,520.34c-4.04-.52-8.07-1.14-12.13-1.54-3.9-.38-7.82-.55-11.73-.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.38,588.34c2.22,1.04,4.51,1.95,6.64,3.15,9.74,5.47,20.46,7.62,31.3,9.33,5.72.91,11.47,1.57,17.2,2.39.68.1,1.65.31,1.91.79,4.11,7.52,8.14,15.08,12.15,22.65.16.31.02.77.02,1.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.1,213.56h-12.51v11.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.7,600.06c-.13,12.9-.2,25.79-.44,38.69-.05,2.53.66,4.01,3.17,4.73,2.01.58,3.87,1.7,5.89,2.26,2.32.64,4.57.85,7.08-.22,2.64-1.13,3.25-2.63,3.13-5.21-.17-3.45.61-6.26,2.83-9.54,7.43-11.02,13.81-22.75,20.56-34.24.32-.54.28-1.29.42-1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M925.25,341.35c2.94-2.39,2.48.84,3.09,1.97.82,1.54,1.02,3.3-1.14,3.85-4.39,1.11-6.04,3.8-5.96,8.25.05,2.46-1.06,4.93-1.44,7.43-.76,4.94-2.66,9.86-.09,14.88.56,1.08.41,2.57.44,3.88.16,6.77.27,13.55.41,20.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 794.63,
    y1: 356.59,
    x2: 794.63,
    y2: 340.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 794.64,
    y1: 422.64,
    x2: 794.63,
    y2: 359.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.75,598.11c-.46,6.81-4.46,11.66-9.44,15.56-6.33,4.95-13.19,9.17-21.06,11.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M925.64,351.51c-.26,6.38-.14,12.82-.96,19.13-.34,2.62-2.69,4.97-4.12,7.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M927.98,350.73c1.3,7.69,2.61,15.37,3.91,23.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M403.18,462.11c-2.42-1.18-4.82-2.77-7.33-.26-3.55-4.74-5.63-4.93-8.81-.78-2.24-.92-3.82-4.19-6.92-2.45-1.58.89-2.97,2.09-4.45,3.15l.45,1.03c-2.71-.62-5.41-1.5-8.15-1.75-1.11-.1-2.78.89-3.43,1.88-3.1,4.71-6.24,5.38-10.67,2.34-3.36-2.31-6.87-4.51-10.58-6.18-2.09-.94-4.72-.11-5.73,2.26-.95,2.22-2.41,2.42-4.39,2.33-3.49-.17-4.63,2.31-5.47,5.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M536.92,510.18c-.13,7.56-.26,15.11-.39,22.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.26,576.22c-5.74-1.95-11.35-4.48-17.24-5.71-6.38-1.33-12.99-1.76-19.52-1.99-3.76-.13-7.71.44-11.31,1.55-7.46,2.3-9.26,10.15-3.44,15.4,2.06,1.86,1.87,3.52,1.85,5.6-.14,11.72-.27,23.45-.39,35.17-.03,3.31,2.77,6.06,5.85,5.42,3.96-.83,7.87-1.92,11.73-3.11,2.49-.77,3.1-4.78,1.58-8.95-.04-.11,0-.26,0-.53,5.43-6.02,10.93-12.12,16.42-18.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.51,576.62c-6.78,2.08-13.59,4.05-20.32,6.3-3.99,1.33-7.84,3.08-11.75,4.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M665.97,244.04c-2.22,1.95-4.65,3.72-6.55,5.94-.94,1.1-1.19,3.04-1.21,4.61-.12,7.03-.05,14.07-.05,21.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M640.56,468.75c-16.29.13-32.59.26-48.88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M845.47,651.65c-7.3,5.21-14.6,10.42-21.9,15.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M641.73,468.36c.78-.39,1.55-1.08,2.35-1.12,2.99-.13,6-.21,8.99-.01,3.67.25,5.68,3.94,5.09,8.95-.14,1.17-.78,2.64-.31,3.47,2.62,4.59.99,9.41,1.07,14.12.08,4.69-.06,9.38.07,14.07.03,1.18.73,2.35,1.12,3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.15,569.19c-6.64-3.8-13.52-1.93-20.32-.68-.92.17-1.58,1.72-2.37,2.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.76,577.01c-.13,7.3-.39,14.59-.32,21.88.02,2.51-1.03,3.85-3.2,3.81-2.08-.03-3.22-1.39-3.17-3.81.23-12.63.28-25.27.44-37.91.08-5.99.25-11.98.38-17.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.73,593.42c-7.17,1.3-14.37,2.47-21.49,4.01-1.59.34-2.87,2.01-4.33,3.02-4.84,3.33-10.66,3.02-16.05,3.73-6.68.88-13.55.18-20.31.65-6.35.44-12.51-1.05-18.78-1.22-1.3-.04-2.61.24-3.91.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.62,563.33c4.56-1.43,9.05-3.24,13.71-4.21,5.94-1.24,11.98-1.31,17.98.27,6.23,1.65,7.27,9.13,3.93,13.72-4.72,6.5-12.01,9.15-18.87,11.92-9.22,3.72-18.82,6.77-28.51,9-9.6,2.21-19.48,3.31-29.3,4.37-6.86.74-13.82,1.01-20.71.74-4.59-.18-9.14-1.64-13.69-2.61-3.08-.66-3.66-2.72-2.74-5.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.95,496.5c-2.74-.78-5.45-1.67-8.22-2.32-4.28-1.01-8.6-1.85-12.9-2.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.16,557.08c4.43.91,8.91,1.65,13.29,2.77,8.12,2.08,16.17,4.39,24.26,6.61,8.08,2.21,16.17,4.4,24.23,6.69.74.21,1.32,1,1.97,1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.75,479.3c-2.09.13-4.43-.31-6.21.5-5.4,2.46-10.98,1.31-16.47,1.38-3.12.04-3.95,1.18-3.13,3.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420,489.47c.13,5.47.24,10.94.4,16.41.05,1.57.25,3.13.38,4.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.83,585.6c2.22,4.04,4.44,8.07,6.65,12.12,2.71,4.99,1.02,10.42,1.57,15.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.85,468.75h48.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.98,193.63c-1.69,0-3.41.18-5.08-.03-10.32-1.27-17.31,3.57-19.43,11.4-1.11,4.1-1.03,8.56-1.26,12.86-.19,3.38-.04,6.77-.04,10.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.21,570.36c-4.3-1.17-8.58-2.45-12.91-3.48-2.56-.61-5.2-.82-7.81-1.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M421.17,486.34c1.81,1.38,2.47,3.08,2.42,5.47-.12,5.6.18,11.2.31,16.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.4,642.27c-6.26-2.74-12.51-5.48-18.78-8.2-.49-.21-1.04-.27-1.56-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.34,353.47c4.95.13,9.91.28,14.86.39,6.65.15,13.3.33,19.94.38,8.34.07,16.69.06,25.03,0,5.08-.04,10.17-.24,15.25-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.21,469.53h-20.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.75,488.29c-5.91.24-11.79-.06-17.59-1.22-.98-.2-1.8-1.07-2.75-1.5-3.99-1.8-8.1.45-8.6,4.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.98,596.94c-3.91,6.51-7.82,13.03-11.73,19.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.42,521.51c1.96-.39,2.39-1.61,2.39-3.52.03-9.77.19-19.54.35-29.31.08-4.82.31-9.64.37-14.46.07-5.73-.07-11.47.05-17.19.07-3.43-.9-5.23-3.16-5.08-2.51.16-3.63,2.04-3.56,5.08.14,5.6.04,11.2.04,16.8,0,7.82.05,15.63-.01,23.45-.07,7.95-.25,15.89-.38,23.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.8,581.31c-6.65-3.78-13.3-7.56-19.94-11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M874.41,495.33c-6.18-1.09-11.98.25-17.61,2.54.02,2.8.96,4.39,3.92,4.55,3.01.16,6,.73,9,1.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.37,356.59h-75.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.64,425.37h-74.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.64,423.03c-18.51-.13-37.02-.26-55.53-.39-.91,0-1.82,0-2.74,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.43,615.7c-5.87,3.26-11.72,6.53-17.61,9.75-.56.3-1.29.28-1.94.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.02,425.76c-6.91-.13-13.82-.35-20.73-.37-17.86-.05-35.72-.02-53.58-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.01,542.22c-4.56-.91-9.1-1.99-13.71-2.57-.77-.1-2.3,1.8-2.61,2.99-.55,2.11-1.71,2.29-3.59,2.84-5.85,1.71-11.51,4.03-17.25,6.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602.62,522.29c-2.26-4.27-6.22-2.04-9.39-2.22-2.97-.17-5.98.76-8.99.99-.75.06-1.86-.51-2.29-1.14-2.19-3.18-4.22-6.48-6.31-9.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.32,355.42c-1.04,6.38-2.09,12.77-3.13,19.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.02,550.82c-.39-.39-.72-1.03-1.18-1.14-11.07-2.65-22.15-5.25-33.23-7.84-.25-.06-.52,0-.78,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.64,571.93c-3.08-1.38-5.98-1.63-9.43-.53-5.04,1.6-10.39,2.21-15.59,3.29-.43.09-.79.5-1.18.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.34,356.98h74.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.45,548.48c12.64,2.74,25.29,5.47,37.93,8.22.55.12,1.05.5,1.57.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1021.45,514.87c-5.88,2.97-12.23,2.05-18.37,1.82-4.9-.18-9.99-.92-13.72-4.92-.31-.33-1.19-.57-1.51-.37-4.58,2.86-9.41.83-14.1.69-6.26-.19-12.52-.67-18.77-1.16-1.84-.14-3.65-.74-5.48-1.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M411.79,435.14c.75-.45,1.5-.89,2.78-1.66-.23,5.12,3.49,8.87,2.75,13.79-.31,2.1-.56,4.45,1.86,5.91.38.23.46,1.26.4,1.89-.37,4.05,1.35,7.27,3.94,10.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.12,507.83c-3.29.69-4.54-2.45-5.68-4.04-3.63-5.09-7.76-6.51-13.51-4.24-1.24.49-2.85-.01-4.27.09-2.19.16-4.22.87-5.06,3.11-2.6,6.9-8.33,7.49-14.49,7.46-1.43,0-2.87.48-4.3.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.38,454.29c-3.91-3.78-7.65-7.77-11.83-11.21-1.29-1.06-3.81-.65-5.76-.91"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 739.49,
    y1: 425.69,
    x2: 809.87,
    y2: 425.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M889.66,518.39c-6.13.13-12.25.26-18.38.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M641.34,469.93v18.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M425.08,467.58c6.15-1.15,12.29-1.33,18.66-.06-4.79,3.2-9.16,6.16-13.59,9.03-1.61,1.04-3.38,1.84-5.07,2.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.34,473.83c.15-3.21-2.77-2.15-3.92-2.19-5.72-.21-11.47.11-17.2.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M786.03,470.32c-1.53-2.17-3.75-2.74-6.26-2.75-1.15,0-2.06.18-3.24-1.05-3.55-3.68-10.29-3.61-14.39-.55-.79.59-2.04.59-3.09.82-1.3.29-2.63.43-3.9.81-1.34.4-2.82.76-3.87,1.6-1.5,1.19-2.66,2.8-3.96,4.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.42,618.43c-.39,5.86-.78,11.72-1.17,17.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M994.86,505.49c8.15-1.04,15.83,1.01,23.48,3.47,3.51,1.13,4.17,3.58,3.88,6.69-.27,2.8-2.49,3.12-4.67,3.56-.58.12-1.05.74-1.57,1.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 988.6,
    y1: 359.72,
    x2: 934.95,
    y2: 359.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M928.38,341.37h60.22s0,95.69,0,95.69h-40.66s-3.83.58-4.3,2.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 739.49,
    y1: 423.03,
    x2: 809.88,
    y2: 423.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 794.64,
    y1: 437.1,
    x2: 794.64,
    y2: 426.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M794.63,359.72h15.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M739.88,359.72h54.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.6,505.88c-1.82,1.43-3.49,3.17-5.52,4.21-2.01,1.04-4.38,1.88-6.61,1.93-4.16.11-8.35-.28-12.5-.74-1.75-.19-3.35-.82-3.21-3.46.27-5.2.04-10.42.09-15.63.03-3.08,1.02-3.66,4.29-3.56,4.82.16,9.65.08,14.47,0,.79-.01,1.56-.49,2.35-.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M964.35,521.12c-5.47-.26-10.95-.52-16.42-.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.15,430.84c.91,4.3,1.84,8.59,2.72,12.9.13.63.27,1.45-.02,1.93-2.36,3.94-2.83,9.24-7.81,11.28-.69.28-1.79-.45-2.71-.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M958.1,526.98c4.69,2.87,9.38,5.74,14.08,8.59,2.2,1.33,4.43,2.61,6.64,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M909.6,494.55c8.6,0,17.21.2,25.81-.05,10.96-.32,21.9-1,32.85-1.51,1.55-.07,3.1-.26,3.57,1.94.23,1.1.99,2.1,1.52,3.14.89,1.76,2.3,2.64,4.3,2.75,3.39.19,6.78.66,10.17.72,3.24.06,4.56,2.7,6.67,4.32,1.05.81,2.33,1.33,3.5,1.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.08,337.83v16.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.29,576.62c3.86-.97,7.37.41,10.96,1.54,4.92,1.54,9.91,2.84,14.84,4.36,1.37.42,2.62,1.27,3.92,1.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.81,628.59c-5.34-1.95-10.69-3.91-16.03-5.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M840,514.48c3.78,6.77,7.54,13.56,11.38,20.3.33.58,1.26.81,1.91,1.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 753.97,
    y1: 340.18,
    x2: 753.96,
    y2: 356.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 750.84,
    y1: 340.57,
    x2: 750.83,
    y2: 356.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.91,426.16c-1.04,4.43-1.73,8.99-3.28,13.23-.79,2.18-.29,3.37.94,4.73.99,1.09,1.92,2.36,3.15,3.08,2.65,1.55,4.36,3.1,3.63,6.73-.51,2.56,1.78,3.65,5.33,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602.62,472.27c-.13,5.21-.26,10.42-.39,15.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M610.83,399.58c-2.05-1.88-3.51-.14-4.18,1.23-.69,1.42-1.09,3.84-.34,4.89.95,1.32,3.23,2.4,4.9,2.34,4.81-.17,8.78,1.69,11.39,5.97.5.82,1.52,1.33,2.31,1.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.34,337.83v15.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.29,597.72c-1.82,3.52-3.25,7.35-5.64,10.43-1.27,1.64-1.81,2.95-1.8,4.82.02,6.51,0,13.03,0,19.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M840.78,504.71c-.91-.26-1.91-.37-2.72-.81-2.72-1.47-5.51-.73-7.05,1.98-1.27,2.24-.37,4.69,2.77,5.77,2.51.87,4.57,3.48,7.84,2.18.52-.21,2.01,1.27,2.64,2.23,3.09,4.76,6.04,9.61,9.04,14.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.95,423.03h15.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M662.45,317.51c0,3.91.06,7.82-.04,11.72-.03,1.31-.49,2.61-.75,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.98,337.83v15.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M478.27,473.05c.13,5.21.26,10.42.39,15.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.11,337.83c-.13,5.21-.26,10.42-.39,15.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.66,509.01c3.26,0,6.52.12,9.78-.03,6.52-.3,13.04-.76,19.55-1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.45,337.83v15.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.18,337.83c.13,5.21.26,10.42.39,15.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M993.29,468.75c-.68-4.56-.91-4.71-5.96-3.89-1.63-3.07-3.86-5.02-7.72-5.24-2-.11-3.86-1.84-5.88-2.57-6.62-2.37-10.11-1.38-14.46,3.88-2.48-1.37-4.66-2.25-7.53-.13-2.12,1.57-5.08,2.08-7.75,2.77-.61.16-1.67-.82-2.3-1.49-2.11-2.23-4.57-3.08-7.44-1.9-2.89,1.18-4.14,3.31-3.99,6.62.26,5.59.07,11.21.07,17h-4.69c0-6.44.05-12.7-.02-18.95-.06-5.34-.25-10.68-.38-16.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.69,605.93c-3.46,6.07-2.39,11.55,3.13,16.02,1.15.93,2.34,1.83,3.52,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.71,388.25c-5.74-.13-11.47-.26-17.21-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.38,337.83c-.13,5.08-.26,10.16-.39,15.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.12,494.16c-3.91.39-7.82.81-11.73,1.16-1.16.1-2.34.02-3.52.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M851.34,237.79c.13-12.11.13-24.23.49-36.34.08-2.63,1.27-5.29,2.29-7.8,1.39-3.44,4.33-4.47,7.77-3.89,3.68.62,7.65.83,10.88,2.45,7.17,3.59,8.57,10.61,8.63,17.84.07,9.12-.21,18.24-.34,27.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361.34,467.19c.33,1.55,1.48,3.24-1.55,3.64-1.16.15-2.14,1.65-3.25,2.57-3.29-1.45-6.59-.55-8.85,2.81-1.62,2.4-1.27,4.76.57,6.17-.9,2.09-1.37,4.3-2.65,5.86-2.14,2.61-1.03,4.55.44,6.73.44.66.55,1.54.81,2.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.24,498.06c-.13,1.95-.29,3.91-.38,5.86-.09,1.83.54,3.95-2.35,4.36-.58.08-1.53,1.01-1.5,1.49.32,4.72-2.96,3.86-5.92,4.42-5.3,1.01-10.47,2.68-15.65,4.21-1.92.57-3.35.77-3.53-1.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M542.79,570.36c4.95,4.17,9.91,8.34,14.86,12.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.37,390.59h-14.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.2,390.59h-14.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.17,337.83v14.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.83,337.83v14.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M948.91,509.01c-3.72.26-7.43.56-11.15.75-1.03.05-2.1-.42-3.12-.32-2.13.19-2.93-.53-3.21-2.76-.5-3.94-1.48-7.83-2.27-11.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.49,337.83v14.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M776.25,340.95v14.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.36,337.83v14.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.2,387.86h-14.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 940.09,
    y1: 341.74,
    x2: 940.11,
    y2: 356.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.73,337.83v14.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M674.58,455.07c-.78-.39-1.72-.62-2.31-1.21-1.04-1.02-1.87-2.26-3.45-4.23-2.02,3.04-3.61,5.41-5.19,7.79"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 957.31,
    y1: 341.37,
    x2: 957.32,
    y2: 356.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.19,422.64c-4.82.13-9.65.26-14.47.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.62,593.81c-4.82-.26-9.65-.52-14.47-.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.28,594.98c7.71,3.55,15.54,3.68,23.46.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 936.97,
    y1: 359.72,
    x2: 936.97,
    y2: 383.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.93,494.16c2.79-2.7,2.85-3.28-.42-4.62-2.73-1.12-5.71-1.63-8.57-2.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.08,501.19c-.26,4.82-.52,9.64-.78,14.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.17,553.56c1.3-.65,2.76-2.05,3.88-1.83,5.01,1.01,9.94,2.47,14.88,3.8.31.08.53.5.79.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.52,637.19c-1.56-.39-3.11-.95-4.7-1.14-3.24-.38-6.51-.56-9.77-.82"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 936.97,
    y1: 341.74,
    x2: 936.98,
    y2: 356.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 974.77,
    y1: 342.13,
    x2: 974.77,
    y2: 356.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.9,501.58c.13,4.82.26,9.64.39,14.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.11,387.86h14.47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 971.78,
    y1: 341.74,
    x2: 971.78,
    y2: 356.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.58,390.59h-14.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M445.03,337.05h195.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M597.54,469.93c-.13,3.13-.24,6.25-.4,9.38-.08,1.57-.25,3.13-.38,4.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.37,543.01c-.13,5.6-.26,11.2-.39,16.8-.13,5.34-.26,10.68-.39,16.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M608.49,509.4c4.56,3.26,9.12,6.51,13.69,9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.63,549.65c-7.69,1.69-15.38,3.39-23.07,5.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M886.53,494.55c7.43.13,14.86.26,22.29.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M638.6,393.72c-1.52-3.32-4.18-4.62-7.38-3.02-2.14,1.07-1.97-1.8-3.59-1.33-2.4.69-4.48-.62-6.67-1.43-1.26-.47-2.93-.39-4.24,0-1.29.38-3.31,1.4-3.38,2.27-.25,3.28-5.81,4.04-3.69,8.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M913.51,440.22c-2.26,2.27-1.14,4.9-.72,7.41.08.46,1.02,1.17,1.49,1.12,2.62-.26,5.22-.72,7.83-1.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.99,423.03c5.61.13,11.21.26,16.82.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M857.59,499.63c4.56.39,9.12.78,13.69,1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M987.43,505.88c1.16,3.38,4.62,4,7.04,5.86,1.69,1.3,3.39,2.61,5.08,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.23,469.53h-13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.26,503.14c-2.74,2.61-5.37,5.34-8.27,7.74-.9.75-3.07,1.25-3.74.72-1.36-1.1-.55-2.56.64-3.8,2.44-2.52,4.72-5.18,7.07-7.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M971.39,483.6c-4.43-.26-8.86-.52-13.3-.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 940.5,
    y1: 421.86,
    x2: 987.43,
    y2: 421.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 797.76,
    y1: 392.93,
    x2: 810.67,
    y2: 392.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M979.6,526.2c0,7.82.01,15.63-.02,23.45,0,.78-.24,1.56-.37,2.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 988.59,
    y1: 424.59,
    x2: 940.51,
    y2: 424.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M713.29,501.97c0-.13.02-.26,0-.39-.84-5.4-1.2-7.81-9.22-5.4-.65-3.58-1.53-7.04-6.43-6.38-.33.05-.87-.67-1.15-1.12-2.57-4.14-5.06-4.87-9.69-2.58-1.47-2.24-3.2-4.53-5.97-1.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.37,414.43c-.01,2.68,1.45,3.34,3.91,3.17,2.99-.2,6.01.11,8.98-.14.96-.08,1.83-1.21,2.74-1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.95,225.67c8.47-.13,16.95-.27,25.42-.37.91-.01,1.82.24,2.74.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.5,519.17c-1.24,1.95-3.29,3.8-3.55,5.88-.64,4.97.25,5.74,5.3,7.82,1.88.77,3.66,1.8,5.48,2.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M883.01,502.36c2.98.56,5.96,1.12,9.17,1.72.06.88.13,2.12.21,3.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.02,545.74c-.52,1.82-.96,3.68-1.58,5.47-2.97,8.61-5.98,17.2-8.98,25.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 773.52,
    y1: 356.59,
    x2: 810.67,
    y2: 356.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 797.76,
    y1: 390.19,
    x2: 810.28,
    y2: 390.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M856.42,510.18c-4.17-1.3-8.34-2.61-12.51-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.86,538.32c2.61,9.51,5.2,19.02,7.84,28.52.23.83.76,1.57,1.15,2.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "881.06 210.04 867.77 210.04 867.77 221.37 880.67 221.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.49,492.2c-2.63-4.1-2.8-8.64-2.73-13.22.39-.14.78-.29,1.18-.43,1.82,4.42,3.64,8.84,5.46,13.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.15,353.86c.26,5.21.52,10.42.78,15.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M918.6,471.88c-1.52-2.75-3.86-3.47-6.63-2.3-1.95.82-4.3,1.63-3.54,4.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.12,625.47c.13,0,.27-.04.39,0,5.76,2.13,8.9,6.6,11,12.09.34.9,1.26,1.58,1.91,2.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M657.37,253.03c-3.91,3.91-7.82,7.82-11.73,11.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.32,427.33c1.29,4.04,2.58,8.08,3.88,12.16-2.7,2.57-5.39,5.24-8.23,7.72-.58.51-1.78.32-2.69.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M936.59,415.99c2.09,4.56,4.23,9.09,6.23,13.69,1.05,2.41,1.85,4.94,2.76,7.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.74,475.4c4.69.78,9.37,1.72,14.08,2.3,5.58.69,11.21,1.08,16.81,1.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "880.67 207.3 867.77 207.3 867.77 190.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.45,639.93c-3.91,1.56-7.82,3.13-11.73,4.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M961.62,498.85c-1.04.13-2.1.2-3.13.4-3.26.62-6.51,1.36-9.78,1.91-1.27.21-2.6.03-3.9.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.85,229.19v11.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.59,229.19v11.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 988.59,
    y1: 392.93,
    x2: 974.77,
    y2: 392.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.83,603.19c-1.5,8.1.77,7.22,8.21,11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.91,477.74c1.96,3.91,3.91,7.82,5.87,11.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.32,466.8c-2.84-2.68-5.9-3.6-9.39-1.17-3.11-2.19-5.09,3.25-8.26,1.25-.29-.18-1.28.67-1.9,1.1-2.69,1.83-6.11,1.43-7.8-1.19-5.4-8.4-10.86-4.66-14.89,1.57-.55.85-1.21,1.63-1.82,2.44-4.17-2.91-5.56-2.73-9.51,1.08q-3.1-1.36-6.26.78c-3.32-2.79-4.69-2.73-8.99.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "940.09 359.72 940.09 367.92 940.09 421.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 974.77,
    y1: 424.59,
    x2: 974.77,
    y2: 436.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 971.78,
    y1: 424.59,
    x2: 971.78,
    y2: 436.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1031.61,472.27c-2.36-2.86-4.81-5.4-9.02-3.18-.46.24-1.33-.1-1.91-.38-.47-.22-.91-1.15-1.17-1.08-3.12.86-6.3-.34-8.22-.14-1.72-1.22-2.99-2.17-4.32-3.04-.73-.47-2.04-1.32-2.26-1.11-3.29,3.08-8.09.36-11.41,3.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M935.41,375.35c.78-1.04,2.36-2.21,2.21-3.11-.76-4.8-4.7-16.95-4.95-17.61-.99-2.62-.96-5.85-4.3-7.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 954.2,
    y1: 424.98,
    x2: 954.2,
    y2: 436.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 957.32,
    y1: 424.98,
    x2: 957.32,
    y2: 436.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M403.18,511.74c-3.78,1.82-7.56,3.65-11.34,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.67,496.11c-.13,3.78-.26,7.56-.39,11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.93,376.52c-.26,3.78-.52,7.56-.78,11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M452.85,316.73c-1.69-.13-3.39-.36-5.08-.37-7.82-.04-15.64-.06-23.46,0-4.3.03-8.6.24-12.91.37"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 974.77,
    y1: 390.19,
    x2: 988.59,
    y2: 390.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.9,317.12c-4.17,4.43-8.35,8.85-12.51,13.29-1.2,1.28-2.35,2.6-3.52,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.41,541.83c-.13,3.65-.26,7.3-.39,10.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1000.33,509.4c3.52,2.21,7.04,4.43,10.56,6.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.05,426.16v10.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 797.76,
    y1: 426.16,
    x2: 797.76,
    y2: 437.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.71,426.16c.13,3.65.26,7.3.39,10.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.26,426.16c.13,3.65.26,7.3.39,10.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.39,426.16c-.13,3.65-.26,7.3-.39,10.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 776.25,
    y1: 426.16,
    x2: 776.25,
    y2: 437.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M773.13,426.16v10.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.11,426.16v10.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.79,426.16c-.13,3.65-.26,7.3-.39,10.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.34,426.16v10.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.69,426.16v10.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 753.97,
    y1: 426.16,
    x2: 753.97,
    y2: 437.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 750.84,
    y1: 426.55,
    x2: 750.84,
    y2: 437.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.93,350.73c-3.65,2.57-3.99,6.99-5.87,10.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.1,493.37c2.37,5.12,7.67,4.3,11.77,5.32,8.28,2.07,16.85,2.14,25.38,2.15,2.08,0,3.74-.44,5.08-2.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.03,390.98h-10.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M834.52,471.1c-.91-.65-1.75-1.5-2.76-1.9-1.22-.48-2.72-1.06-3.86-.74-2.59.73-5.08,1.77-7.85,1.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M750.05,390.2h-10.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.95,501.19v10.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.29,337.44c-1.96,2.61-3.88,5.24-5.89,7.8-.5.64-1.28,1.06-1.93,1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.03,387.86h-10.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M938.54,526.98c-.66,4.01.04,5.62,2.74,6.25,2.4.56,4.84-1.06,6.16-4.74-1.8-.64-3.56-1.71-5.39-1.83-6.77-.46-13.55-.7-20.33-.78-1.56-.02-3.25.74-4.66,1.54-1.94,1.09-3.63,2.62-5.51,3.84-4.94,3.2-5.83,5.34-4.68,11.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M918.01,526.4c-2.54-.46-5.07-1-7.63-1.35-3.51-.48-7.04-.8-10.56-1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.04,496.11c-1.43-.26-2.86-.65-4.3-.75-1.95-.13-3.91-.03-5.86-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635.47,421.07c-3.39-.13-6.78-.26-10.17-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.54,563.33c1.96.65,3.94,1.23,5.86,1.98,1.35.53,2.62,1.28,3.92,1.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M749.66,392.94h-10.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.37,510.96c-6,5.73-11.99,11.46-17.99,17.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.34,474.62c-2.46,2.27-5.62,2.02-8.6,2.34-3.91.42-7.84.63-11.72,1.23-3.12.48-6.17,1.4-9.5,2.18-.53,3.43,1.02,5.71,4.79,6.8,3.11.9,6.14,2.07,9.4.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.57,551.6c1.43,4.82,2.87,9.64,4.3,14.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.14,541.83c.13,3.39.26,6.77.39,10.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M963.96,502.36c-3.39-.13-6.78-.26-10.17-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.25,598.89c.13,3.26.26,6.51.39,9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M884.19,499.63c3.39.13,6.78.26,10.17.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.78,543.01v9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.72,498.06c.13,1.82.15,3.66.43,5.47.21,1.33.75,2.61,1.14,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M921.34,402.32c-.52.39-1.51.8-1.49,1.17.12,2.74.45,5.47.71,8.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M910.39,499.24c-.91-.52-1.8-1.42-2.74-1.48-1.94-.13-3.91.18-5.86.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M951.06,502.75c3,.78,6,1.56,8.99,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M981.56,516.82c-2.6,2.34-5.75.64-8.6,1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.31,560.2c.13,4.95.26,9.9.39,14.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.65,543.01c-.13,3-.26,5.99-.39,8.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M871.67,498.85c-3-.13-6-.26-8.99-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.91,615.31c-3-1.3-6-2.61-8.99-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M921.34,337.83c.13,4.3.26,8.6.39,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M870.11,516.82c1.01,3.47-1.69,7.72-5.47,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.05,540.27c.78,2.74,1.56,5.47,2.35,8.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.14,501.19v8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.56,483.21c-1.96.13-3.93.15-5.86.46-.59.09-1.54,1.07-1.47,1.48.14.72.82,1.69,1.48,1.9,1.36.42,2.86.41,4.64.62,1.34-2.95,2.84-6.24,4.33-9.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M520.11,546.13c0,.13-.05.3,0,.39,3.38,5.09,8.15,6.87,14.07,5.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.05,501.58c-.13,2.74-.26,5.47-.39,8.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.12,486.34c-1.56,0-3.13-.04-4.69.02-.66.02-1.75.06-1.89.4-1.84,4.61-6.22,3.27-9.47,3.73-5,.71-10.2,0-15.22.64-6.83.89-13.58,2.47-20.33,3.88-.51.11-.8,1.23-1.19,1.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1030.83,487.12c-2.73,1.93-3.49,4.65-3.13,7.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.95,500.02c-1.56,2.74-3.13,5.47-4.69,8.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M906.87,525.42c.26,2.74.52,5.47.78,8.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.47,493.37c1.56.52,3.11,1.38,4.7,1.49,2.73.18,1,1.8,1.17,2.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.65,500.41c.39,2.21.42,4.58,1.26,6.61,1.24,3,3.04,5.77,4.61,8.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.03,329.63c.26,2.61.52,5.21.78,7.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M968.65,526.98c.13,1.04.26,2.08.46,3.62,1.48.09,3.05.19,4.63.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.23,484.78c-2.61.52-5.21,1.04-7.82,1.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M606.14,582.87c2.61,1.3,5.21,2.61,7.82,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M916.25,495.72c2.03,2.66,3.45,5.5,2.63,9.51-4.35-.3-8.79-.46-13.17-1.07-.64-.09-4.54-.4-1.98-3.35-1.3-.65-2.59-1.78-3.92-1.84-1.8-.08-3.64.66-5.47,1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M924.86,466.02c-3.47-.58-5.31,1.21-6.26,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.8,285.46c1.75-4.5,1.59-6.7-.91-11.18-3.17,2.89-3.43,6.59-3.39,10.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M935.02,441.01c.39,2.61.78,5.21,1.17,7.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M992.12,523.86c2.48,1.17,4.95,2.34,7.43,3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.12,488.68c-2.48.13-4.95.26-7.43.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.79,501.58v7.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.9,520.34c-2.35,1.04-4.69,2.08-7.04,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.22,588.73c3.52,5.91,6.37,12.25,11.34,17.2,1.4,1.4,2.84,2.26,4.7.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.01,562.94c-.13,2.34-.26,4.69-.39,7.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M902.57,501.58c-2.35-.13-4.69-.26-7.04-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M683.57,303.44c0,1.56-.17,3.15.03,4.69.84,6.41-1.32,11.11-7.46,13.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.22,482.04c-2.48.52-4.95,1.04-7.43,1.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M844.69,514.87c2.26-1.03,3.55.12,4.72,1.94,1.31,2.03,2.84,3.93,4.27,5.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M936.2,495.33c.45,2.75.9,5.49,1.47,8.94-1.75.37-3.76.79-5.77,1.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.49,475.01c-1.08-3.48-2.63-4.43-5.46-3.1-1.95.92-3.78,2.12-4.81,2.71h-9.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.08,494.94h-7.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.88,542.62v7.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.32,491.03c-2.85,3.05-6.6.52-9.78,1.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.68,628.98c2.35,1.04,4.69,2.08,7.04,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M920.95,500.8c2.85,1.7,3.49,3.84,2.35,7.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.09,478.52c0,.39-.13.84.02,1.16.7,1.5,2.93,3.03.69,4.6-1.47,1.03-3.56,1.23-5.41,1.63-1.8.39-3.64.55-5.47.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M638.6,396.06q-2.62,3.49.78,5.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.73,426.16c-.13,3.65-.26,7.3-.39,10.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M886.53,492.2c-1.69,3.39-3.41,6.77-5.08,10.16-.95,1.94-1.83,3.9-2.74,5.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.39,646.96c-2.22-1.04-4.43-2.08-6.65-3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M924.86,480.48h-6.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M904.13,500.41c4.43-.26,8.86-.52,13.3-.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.12,510.96c-2.22-.39-4.43-.78-6.65-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M921.73,502.36c.52,3.91,1.04,7.82,1.56,11.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M922.9,494.94c.13,2.08.26,4.17.39,6.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M941.67,494.94c.26,2.08.52,4.17.78,6.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M895.53,517.21c2.09.26,4.17.52,6.26.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.5,609.83c2.09.91,4.17,1.82,6.26,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M653.46,317.12c-.13,2.08-.26,4.17-.39,6.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.02,501.19c-.13,3.13-.26,6.25-.39,9.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.37,646.18c-2.09.78-4.17,1.56-6.26,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.47,317.12c.13,2.08.26,4.17.39,6.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.16,455.86c-1.96,2.28-3.85,2.4-5.89.02-1.31-1.53-2.85-2.89-4.28-4.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.31,561.76c-1.82.78-3.65,1.56-5.47,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.27,563.33c-.13,1.95-.26,3.91-.39,5.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M931.11,509.4c-1.07,4.58,1.43,6.52,7.04,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M968.26,510.57c-.62-3.9-3.92-3.93-6.66-4.22-3.35-.35-6.77-.08-10.25-.08-.47-2.04-.78-3.37-1.08-4.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.93,597.33v5.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.27,501.19v5.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.87,485.56c1.43,1.56,2.87,3.13,4.3,4.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.31,496.11h-5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M945.19,495.33c-.25,1.96-.49,3.91-.76,6.05-2.09.33-4.18.65-6.28.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M921.73,341.37h2.89s.69,3.9,1.02,5.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.12,501.58c-2.73-1.45-4.08-5.54-8.21-4.28-.43.13-.79.5-1.18.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M920.16,494.94c-.28,1.72,1.73,3.97-1.17,5.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.19,582.09c-.39,1.95-.78,3.91-1.17,5.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.35,500.8c-5.87,0-11.73.07-17.6-.04-2.35-.04-4.69-.49-7.04-.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.53,566.45c.78,1.82,1.56,3.65,2.35,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.19,566.45c1.82.65,3.65,1.3,5.47,1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.77,380.04c.68-3.17,2.75-1.22,4.3-1.17,4.17.13,8.34.26,12.51.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.31,540.66v8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M660.5,241.69c1.82.26,3.65.52,5.47.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.91,665.72c-.26,1.82-.52,3.65-.78,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M877.54,491.03c-3.13,5.6-6.26,11.2-9.39,16.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M653.07,505.1c1.69,1.17,3.39,2.34,5.08,3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.24,546.13c.26,1.69.52,3.39.78,5.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.45,409.74c2.87.13,5.74.26,8.6.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.12,449.6c-.78,1.56-1.59,3.11-2.24,4.73-.03.07,1.46.74,2.24,1.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M942.84,527.37c.13,1.69.26,3.39.39,5.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.41,443.35c-1.2,1.16-1.52,4.75-4.3,1.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.84,376.52c-1.69.52-3.39,1.04-5.08,1.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.41,488.29c-.32-1.58-.63-3.16-.92-4.61-1.55-.47-2.86-.86-4.16-1.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.9,326.11c-.26,1.69-.52,3.39-.78,5.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M914.3,438.27c-.27,2.35,1.98,2.19,3.13,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.52,525.03c-1.3.91-2.61,1.82-3.91,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.49,636.8c-1.56.52-3.13,1.04-4.69,1.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M974.13,526.98c.13,3,.26,5.99.39,8.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1069.16,532.06c-.78,1.3-1.56,2.61-2.35,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M932.68,585.21c.13,1.56.26,3.13.39,4.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1010.5,509.4c1.56.78,3.13,1.56,4.69,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.84,507.44h-8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M689.83,575.83c-.26,1.56-.52,3.13-.78,4.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.67,573.49c.52,1.56,1.04,3.13,1.56,4.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M960.44,494.55c1.56,3,3.22,5.95,4.63,9.02.4.86.06,2.06.06,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M922.9,374.57c-1.43-.26-2.87-.52-4.3-.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M991.92,504.32c-3.45.91-7.05,1.49-10.31,2.85-2.21.92-3.43.69-4.32-1.3-.67-1.5-1.07-3.11-1.59-4.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M673.4,532.85c.26,1.3.52,2.61.78,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M438.77,652.43v3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.9,657.12c-.13,1.3-.26,2.61-.39,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M916.25,510.57l-3.52,1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M693.35,578.57c-.65,1.17-1.3,2.34-1.96,3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M445.81,551.6c-.26,1.3-.52,2.61-.78,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.94,550.04c.13,1.3.26,2.61.39,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.38,536.75c.26,1.3.52,2.61.78,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M608.88,536.75c-.13,1.3-.26,2.61-.39,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.62,311.26c1.04.91,2.09,1.82,3.13,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.98,435.53c-2.36,4.93-2.11,6.38,1.56,8.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M912.73,623.51c.13,1.3.26,2.61.39,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.22,584.04c.91.91,1.82,1.82,2.74,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M980.78,504.32h-3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M466.53,412.09c-.78,1.04-1.56,2.08-2.35,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.44,632.11c-1.04.26-2.09.52-3.13.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M872.06,631.33c.26,1.04.52,2.08.78,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M408.27,569.58c-.52,1.04-1.04,2.08-1.56,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M509.16,654c-.26,1.04-.52,2.08-.78,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M473.18,618.82c.26,1.04.52,2.08.78,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M753.18,671.97c-1.04-.26-2.09-.52-3.13-.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M506.03,604.75c-.26,1.04-.52,2.08-.78,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M491.95,598.5v3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M854.86,579.74c-.52,1.04-1.04,2.08-1.56,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1055.86,568.8c-.26,1.04-.52,2.08-.78,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M897.09,575.83c.52,1.04,1.04,2.08,1.56,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.91,629.77c-1.04.26-2.09.52-3.13.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M905.69,575.83c-.39.91-.78,1.82-1.17,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M779.77,606.32v3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M403.57,567.24c-.26,1.04-.52,2.08-.78,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M773.12,561.76c-.13,1.04-.26,2.08-.39,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M783.68,606.32c-.26,1.04-.52,2.08-.78,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.32,645.4c.26,1.04.52,2.08.78,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M777.43,562.55c-.52,1.04-1.04,2.08-1.56,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.06,637.58v3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M990.94,644.62c-.52,1.04-1.04,2.08-1.56,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M511.51,607.1c-.52,1.04-1.04,2.08-1.56,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.22,667.28c.26,1.04.52,2.08.78,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M918.99,623.51c-.52,1.04-1.04,2.08-1.56,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M980.78,585.99v3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.07,551.6c-.13,1.04-.26,2.08-.39,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M639.77,553.17v3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M616.31,588.34c2.09,1.04,4.17,2.08,6.26,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.96,634.45c-1.04.26-2.09.52-3.13.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.62,480.09v2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635.86,553.95c.52.78,1.04,1.56,1.56,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M820.44,562.55c-.52.78-1.04,1.56-1.56,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.6,581.31c.26.78.52,1.56.78,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M458.71,465.63c.13.91.26,1.82.39,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M577.2,657.9c-.26.78-.52,1.56-.78,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M756.31,511.74c.39.91.78,1.82,1.17,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.04,658.68c.52.78,1.04,1.56,1.56,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M457.93,410.52c-.78-.26-1.56-.52-2.41-.8-2.5,2.99.27,4.06,2.02,5.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M621.39,465.63c.13.91.26,1.82.39,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M612.4,539.1c-.52.78-1.04,1.56-1.56,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.39,670.41c-.52.78-1.04,1.56-1.56,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M937.76,440.61c-1.69.13-3.81-.34-5,.5-3.48,2.46-6.43,1.94-9.47-.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386.37,520.34c-1.04.52-2.09,1.04-3.13,1.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.83,385.51c-.52.52-1.46,1.01-1.5,1.57-.26,3.51-.37,7.03-.45,10.55-.28,12.64-.77,25.27-.72,37.91.05,11.33.7,22.67,1.1,34.2h34.22v-84.22h-32.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M503.68,385.51c-.39,1.17-1.11,2.34-1.12,3.52-.1,8.86.03,17.72-.07,26.57-.2,16.68-.5,33.35-.76,50.02-.02,1.32,0,2.63,0,4.69h27.37q6.26,0,6.26-6.25v-78.55h-31.28"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(450.38 334.28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "THE "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 40.18,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 53.55,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 70,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 83.56,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 97.44,
    y: 0
  }, "H HOUSE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManorHouse);
export default __webpack_public_path__ + "static/media/manor-house.6ad1764f9f613b36a068171162d19ece.svg";
export { ForwardRef as ReactComponent };